<script setup lang="ts">
  import { computed } from 'vue';
  import MpfBackLink from '../MpfBackLink/MpfBackLink.vue';
  import type { MpfAppBackButtonProps } from './MpfAppBackButton.props';
  import { mpfAppBackButtonDefaults } from './MpfAppBackButton.defaults';

  const props = withDefaults(defineProps<MpfAppBackButtonProps>(), mpfAppBackButtonDefaults);

  const emit = defineEmits<{
    (e: 'go-to-page', value: string): void;
  }>();

  const variant = computed<'app' | 'web' | 'default' | null>(() => {
    if (props.isOpenInNhsApp && props.showBackNhsApp !== false) {
      return 'app';
    }

    if (props.isNhsWebApp && props.showBackNhsAppWeb !== false) {
      return 'web';
    }

    if (props.showBackButton && !props.isNhsWebApp) {
      return 'default';
    }

    return null;
  });

  const appButtonClass = computed(() => (props.goToPage ? `go-to--${props.goToPage}` : null));

  function handAppBackClick() {
    if (!props.goToPage || props.goToPage === 'PP_GO_BACK') return;

    emit('go-to-page', props.goToPage);
  }
  const isHistoryBack = computed(() => props.goToPage === 'PP_GO_BACK');
</script>

<template>
  <div class="mpf-app-back-button">
    <MpfBackLink
      v-if="variant === 'app'"
      text="Back"
      class="nhs-app--back-link"
      :class="appButtonClass"
      :history-back="isHistoryBack"
      @click="handAppBackClick"
    />
    <MpfBackLink
      v-else-if="variant === 'web'"
      text="Back"
      history-back
      class="nhs-app-web--back-link"
    />
    <MpfBackLink
      v-else-if="variant === 'default'"
      text="Back"
      history-back
      :fallback-url="fallbackUrl"
      class="nhs--back-link"
    />
  </div>
</template>
